//React Imports
import React from 'react';

//import components
import  InputElement  from '../../Components/UI/InputElement/InputElement';

import { Aux } from '../../hoc/Aux';
//css imports

//external libraries

//logic model imports
import Item from '../../Model/item';


export default  class InputDetails extends React.Component{
    state={
        //inputValues:[],
        id:'',
        name:'',
        imgUrl:'',
        

    }

    pickValues=(value,inputIdentifier)=>{
        console.log(value,inputIdentifier);
        switch(inputIdentifier){
            case 'id':
                this.setState({id:value});
                console.log("id",this.state);//doubt why not printing
                break;
            case 'name':
                this.setState({name:value});
                break;
            case 'imgUrl':
                this.setState({imgUrl:value});
                break;
            default:
                console.log("[InputDeatails.js] inputIdentifier not found in state",inputIdentifier,this.state)
        }
        console.log(this.state.id,this.state.name,this.state.imgUrl);

    }

    // pickValues=(values)=>{
    //    this.setState({inputValues:values});
    //    console.log("[InputDetails]:pickvalues => state.inputValues",this.state.inputValues);
    // }
    
    makeObject=()=>{
        let id = this.state.id;
        let name = this.state.name;
        let url = this.state.imgUrl;
        const ItemObject = new Item(id,name,url); 
        console.log("itemObject [inputDetails.js]",ItemObject)
        this.props.addItem(ItemObject);
       // this.setState({inputValues:[]});
       // this.inputValues;

    }
    


    render (){
        //console.log("render",this.state.inputValues)
        return (

            <div className="container">
                <Aux>
                    <form className="form">
                        {
                            this.props.queries.map(
                                query=>{
                                    return (
                                        <div className='form-group' 
                                            key={query.queryName}>
                                                <InputElement 
                                                    inputName={query.queryName} queryID={query.queryID}    inputValues={this.state.inputValues}      {...query.queryDetails}
                                                    pickValues={this.pickValues}
                                                   
                                                    />
                                        </div>
                                    );
                                }
                            )
                        }
                    </form>
                </Aux>
                <Aux>
                    <button className='btn btn-success' value="Add"           onClick={this.makeObject}>Add</button>
                    &nbsp;
                    <button className='btn btn-danger' value='Delete'       onClick={this.props.deleteItems}>Delete</button>
                    &nbsp;
                    <button className='btn btn-warning' onClick={this.update}>Update</button>
                    &nbsp;
                    <button className='btn btn-info' onClick={this.props.saveLocal}>Save Local</button>
                    
                    &nbsp;
                    <button className='btn btn-secondary'onClick={this.props.loadLocal}>Load Local</button>
                    &nbsp;
                    <button className='btn btn-success' onClick={this.props.clearLocal}>Clear Local</button>
                    &nbsp;
                    <button className='btn btn-info' onClick={this.props.loadFromServer}>Load from Server</button>
                    &nbsp;
                    <button className='btn btn-primary' onClick={this.props.saveToServer}>Save To Server</button>

                    {/* <button className='btn btn-warning'                             value='Delete' onClick={}>Delete</button>
                    <button className='btn btn-primary'                             value='Subtract' onClick={}>Search</button> */}

                        
                </Aux>
    
            </div>
    
        );
    }


}

//export default InputDetails;


// WEBPACK FOOTER //
// ./src/Containers/InputDetails/InputDetails.js